import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, HashRouter, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import BrokerList from "../pages/Broker/BrokerList";
import EditBroker from "../pages/Broker/EditBroker";
import CreateBoker from "../pages/Broker/CreateBoker";

export const queryClient = new QueryClient();

const Router = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <HashRouter>
        <Routes>
          <Route path="/" element={<BrokerList />} />
          <Route path="/edit/:id" element={<EditBroker />} />
          <Route path="/create" element={<CreateBoker />} />
        </Routes>
      </HashRouter>
      <ToastContainer autoClose={500} draggablePercent={30} />
    </QueryClientProvider>
  );
};

export default Router;
